import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Spline from '../spline.js';

export default class NodeOffsetCurve extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.SPLINE, 'spline', null);

		this.addInput(PARAM_TYPE.FLOAT, 'offset', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.BOOLEAN, 'offset_sides_by_equal_amount', false);

		this.addOutput(PARAM_TYPE.SPLINE, 'spline');
	}

	getType()
	{
		return 'offsetCurve';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pCurveData = inputValues['spline'];
		if(!pCurveData)
			return null;

		let pSpline = new Spline(pCurveData);
		pSpline.offsetCurve(inputValues['offset'], pSpline.getNormal(), inputValues['offset_sides_by_equal_amount']);

		return pSpline.saveToObject();
	}
}